import { Component, OnInit, NgZone, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, ViewRef } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import { ChartsService } from '../charts-service/charts.service';
import { QueryParamsModel, LayoutUtilsService } from 'app/core/_base/crud';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DungChungService } from '../../dung-chung/__services/dung-chung.service';
import { CommonConFig } from '../../dung-chung/__model/common_config.model';
am4core.useTheme(am4themes_material);
@Component({
  selector: 'kt-thong-ke-ton-kho-hien-tai-chart',
  templateUrl: './thong-ke-ton-kho-hien-tai-chart.component.html',
  styleUrls: ['./thong-ke-ton-kho-hien-tai-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe]
})
export class ThongKeTonKhoHienTaiChartComponent implements OnInit {
  chart: am4charts.XYChart;
  chartPie: am4charts.PieChart;
  selectBieuDo: string = "0";
  columnHH: string='';
  columnNCC: string='';
  CONFIG: CommonConFig;
  categoryAxis: any;
  valueAxis: any;

	listId_HH : any[] = [];
	selectId_HH : any[] = [];
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;

	listKho : any[] = [];
	selectKho : string[] = [];
	filteredKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrl: string = '';
  haveElementKho: boolean = false;
  
  // Filter kho
	listIdKho: any[] = [];
	selectIdKho: string[] = [];
	filteredIdKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdKhoFilterCtrl: string = '';
	haveElementIdKho: boolean = false;
	// Filter hàng hóa
	listIdHH: any[] = [];
	selectIdHH: string[] = [];
	filteredIdHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdHHFilterCtrl: string = '';
	haveElementIdHH: boolean = false;
  LoaiBieuDo: any[] = [
    {
      value: "0",
      name: 'Biểu đồ cột'
    },
    {
      value: "1",
      name: 'Biểu đồ tròn'
    }
  ]
  CotThongKeHH: any[] = [
    {
      value: "SoLuongDatMua",
      name: 'Số lượng đặt mua'
    },
    {
      value: "SoLuongConLai",
      name: 'Số lượng còn lại'
    },
    {
      value: "SoLuongDaNhan",
      name: 'Số lượng đã nhận'
    }
  ]
  CotThongKeNCC: any[] = [
    {
      value: "TongTien",
      name: 'Tổng tiền'
    },
    {
      value: "ThanhTien",
      name: 'Thành tiền'
    },
    {
      value: "Thue",
      name: 'Thuế'
    }
  ]
  LoaiThongKe: any[] = [
    {
      value: 'MH',
      name: 'Mặt hàng'
    },
    {
      value: 'NCC',
      name: 'Nhà cung cấp'
    }
  ]


  NhomNCC: any[] = [
    {
      value: '1',
      name: 'Có hệ thống ATTP'
    },
    {
      value: '2',
      name: 'Không có hệ thống ATTP'
    }
  ];
  DenNgayMuaHang;
  TuNgayMuaHang;
  day = new Date();
  DayNow;
  MonthNow;
  YearNow;
  isSelectedLoaiTK: boolean = true;
  config = {

  }
  constructor(
    private zone: NgZone,
    private chartsservice: ChartsService,
    private changeDetect: ChangeDetectorRef,
    private DungChungService: DungChungService,
    private layoutUtilsService: LayoutUtilsService,
  ) {

  }
  ngAfterViewInit(): void {
   
    // this.loadBieuDo();
  }
  configChart(Xfield, Xtext, YText, Tooltip, data, _series: any[] = []) {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
      let chart = am4core.create("charttkht", am4charts.XYChart);
      chart.logo.height = -15;
      chart.scrollbarX = new am4core.Scrollbar();
      chart.cursor = new am4charts.XYCursor();
      chart.legend = new am4charts.Legend();
      chart.cursor.lineY.disabled = true;
	    chart.cursor.lineX.disabled = true;
      //SET DATA
      chart.data = data;


      chart.paddingRight = 20;
      chart.numberFormatter.numberFormat = "#a";
      chart.numberFormatter.bigNumberPrefixes = [
        { "number": 1e+3, "suffix": "N" },
        { "number": 1e+6, "suffix": "Tr" },
        { "number": 1e+9, "suffix": "T" }
      ];

      //   var title = chart.titles.create();
      //   title.text = "BIỂU ĐỒ TỔNG HỢP MUA HÀNG";
      //   title.fontWeight = "bold";
      //   title.fontSize = 20;
      //   title.marginBottom = 20;

      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = Xfield;//"MaHH";
      categoryAxis.title.text = Xtext;//"Mã hàng";
      categoryAxis.title.fontWeight = "bold";//"Mã hàng";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 20;
      var label = categoryAxis.renderer.labels.template;
      label.truncate = true;
      label.maxWidth = 200;
      label.tooltipText = "{" + Tooltip + "}";
      categoryAxis.events.on("sizechanged", function (ev) {
        var axis = ev.target;
        var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
        if (cellWidth < axis.renderer.labels.template.maxWidth) {
          axis.renderer.labels.template.rotation = -45;
          axis.renderer.labels.template.horizontalCenter = "right";
          axis.renderer.labels.template.verticalCenter = "middle";
        }
        else {
          axis.renderer.labels.template.rotation = 0;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        }
      });

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = YText;//"Số lượng theo đơn vị tính";
      valueAxis.title.fontWeight = "bold";//"Số lượng theo đơn vị tính";
      for (var i = 0; i < _series.length; i++) {
        let sr1 = _series[i];
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = sr1.valueY;//"SoLuongConLai";
        series.dataFields.categoryX = sr1.categoryX;//"MaHH";
        series.name = sr1.name;//"Số lượng còn lại";
        series.tooltipText = "{name}: [bold]{valueY}[/] ";
        series.stacked = true;
      }     
      this.chart = chart;
    });
    this.changeDetectView();
  }
  configChartPie(value, category, data) {
    console.log("data", data);
    this.zone.runOutsideAngular(() => {
      if (this.chartPie) {
        this.chartPie.dispose();
      }
      var chart = am4core.create("charttkhtPie", am4charts.PieChart);
      chart.legend = new am4charts.Legend();
      chart.logo.height = -100;
      // Add data
      chart.data = data;
      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = value;
      pieSeries.dataFields.category = category;
      pieSeries.ticks.template.disabled = true;
      pieSeries.labels.template.disabled = true;
      pieSeries.alignLabels = false;
      // pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
      // pieSeries.labels.template.radius = am4core.percent(-40);
      // pieSeries.labels.template.fill = am4core.color("white");
      // pieSeries.labels.template.relativeRotation = 90;
      this.chartPie = chart;
    });
    this.changeDetectView();
  }
  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
  }
  ngOnInit() {
    this.CONFIG = new CommonConFig();
    this.selectBieuDo = this.LoaiBieuDo[0].value;
    this.columnHH = this.CotThongKeHH[0].value;
    this.columnNCC = this.CotThongKeNCC[0].value;
    this.ListKho();
		this.ListIdHH();
    this.DayNow = this.day.getDate();
    this.MonthNow = this.day.getMonth() + 1; // Since getMonth() returns month from 0-11 not 1-12
    this.YearNow = this.day.getFullYear();
    this.DenNgayMuaHang = new Date(this.YearNow, this.MonthNow, 0);
    this.TuNgayMuaHang = new Date(this.YearNow, this.MonthNow - 1, 1);
  }
  ListIdHH() {
		let queryParam= new QueryParamsModel({});
		queryParam.filterGroup.IdKho=this.selectKho;	
		this.DungChungService.layDanhSachHHDaNhapKho(queryParam).subscribe(res => {
			if (res && res.status === 1) {
        this.listIdHH = res.data;
        this.filteredIdHH.next(this.listIdHH.slice());
        this.selectId_HH=this.listIdHH.slice(0,20);	
        this.loadBieuDo();
        this.changeDetect.detectChanges();	
      };    
    });    
	}
	filterIdHH() {		
		if (!this.listIdHH) {
			return;
		}
		// get the search keyword
		let search = this.IdHHFilterCtrl;
		if (!search) {
			this.filteredIdHH.next(this.listIdHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredIdHH.next(
			this.listIdHH.filter(ts =>
				(ts.Mahh+' - '+ts.Tenhh).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}

	clearHH(){
		this.selectId_HH=[];
		
		this.changeDetect.detectChanges();
		
	}

	ListKho(){
		this.chartsservice.listKho().subscribe(res => {
			if (res && res.status === 1) {
        this.listKho = res.data;
        this.filteredKho.next(this.listKho.slice());
				this.changeDetect.detectChanges();
			};
		});
	}
	filterListKho() {
		
		if (!this.listKho) {
			return;
		}
		// get the search keyword
		let search = this.KhoFilterCtrl;
		if (!search) {
			this.filteredKho.next(this.listKho.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKho.next(
			this.listKho.filter(ts =>
				ts.TenKho.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	SelectListKho(event: any, dependOnField: string = ''){
		if(this.selectKho.length >= 0 && event.length > 0)
			this.haveElementKho = true;
		if(this.selectKho.length <= 1 && event.length == 0)
			this.haveElementKho = false;
		if(dependOnField != ''){
		}
	}
	ClearListKho(){
		this.selectKho = [];
		this.haveElementKho = false;
		event.stopPropagation();
	}
  filterConfiguration(): any {
    if(this.selectId_HH.length>20){
      this.layoutUtilsService.showErorr('Chỉ được chọn tối đa 20 mặt hàng để xem biểu đồ');
      return;
    }
    const filter: any = {};
		filter.listHH = this.selectId_HH.map(x=>x.IdHh);
    filter.listKho = this.selectKho;
    console.log(" this.selectId_HH",  this.selectId_HH);	
    return filter;
  }
  MapData(data){
    let res= [];
    let grps = this.groupBy(data, "IdHh");    
    console.log("res", grps);     
    grps.forEach(g => {      
      let item = {
        XFields: g[0].MaHH,
        Xtext: g[0].TenHH,
        Series1: 0,
        Series2:0,
        Totals: 0,
      }
      g.forEach(x=>{
        if(x.Tinhtrang){
          item.Series1 +=  x.Soluong
        }
        else{
          item.Series2 +=  x.Soluong
        }
        item.Totals +=  x.Soluong
      })
      res.push(item);    
    });
    return res;
  }
  LoadData() {
    const queryParams = new QueryParamsModel(this.filterConfiguration());
    queryParams.more = true;
    this.chartsservice.getTonKhoHienTai(queryParams).subscribe(res => {
     let result = this.MapData(res.data);   
     console.log("result",result);  
      let seris = [{
        valueY: "Series1",
        categoryX: "XFields",
        name: "Cho phép xuất"
      },
      {
        valueY: "Series2",
        categoryX: "XFields",
        name: "Không cho phép xuất"
      }];
      this.configChart("XFields", "MÃ HÀNG", "Số lượng tồn", "Xtext", result, seris);
    });   
  }
  groupBy (list: any[], key: string): Map<string, Array<any>> {
    let map = new Map();
    list.map(val=> {
        if(!map.has(val[key])){
            map.set(val[key],list.filter(data => (data[key] == val[key])));
        }
    });
    return map;
  }
  LoadDataPie() {
    const queryParams = new QueryParamsModel(this.filterConfiguration());
    queryParams.more = true;
    this.chartsservice.getTonKhoHienTai(queryParams).subscribe(res => {
      //console.log(res);
      let result = this.MapData(res.data);   
      this.configChartPie("Totals","Xtext",  result);
    });
    // this.chartsservice.getDataTongHopMuaHang(queryParams).subscribe(res=>{
    //   console.log("res thmh",res);
    //   this.chart.data=res.data;
    // });
  } 
  changeDetectView() {
    if (!(this.changeDetect as ViewRef).destroyed) {
      this.changeDetect.detectChanges()
    }
  }
  loadBieuDo() {
    console.log("load bieu do");
    if (this.selectBieuDo =="1") {
      this.LoadDataPie();
    }
    else {
      this.LoadData();
    }
  }
  
}
